<template>
    <div class="animated fadeIn">
  
      <b-card class="card-accent-info" header="Documentos">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Documento</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
            
            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            <!--
            <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
          -->
          <b-col cols="auto">
              <b-form-group>
                  <label for="name">Público</label>
                  <b-form-select id="public"
                    v-model="filters.public"
                    :plain="true"
                    :options="publicddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped

                >

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.title && row.item.title.length > 0">
                            <b-col class="small">Título</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.title }}
                            <hr>
                            </b-col>
                        </b-row>

                        <b-row v-show="row.item.files">
                            <b-col class="small">Arquivos</b-col>
                        </b-row>
                        <b-row v-for="fileItem in row.item.files" :key="fileItem.id">
                            <b-col><i class="fa fa-file-o"></i> {{ fileItem.filename }}
                            <hr>
                            </b-col>
                        </b-row>
                       
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedIn }}</b> por <b>{{ row.item.publisherName }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                

                <template v-slot:cell(name)="data">
                  <b-row>
                      <b-col>{{ data.item.name }}</b-col>

                  </b-row>
                  <b-row>
                      <b-col class="font-weight-bold">{{ data.item.title }}</b-col>
                  </b-row>
                  <b-row>

                      <b-col class="small">{{ data.item.description }}</b-col>
                  </b-row>
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatusClick(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>


        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Documento"
              size="lg">
  

              
          <b-nav fill>
            <b-nav-item :active="tabInfo" @click="tabInfo = !tabInfo">Informações do Documento</b-nav-item>
            <b-nav-item :active="!tabInfo" @click="tabInfo = !tabInfo">Arquivo</b-nav-item>
          </b-nav>
      
          <b-card
        header-tag="header"
        footer-tag="footer">
        
        
        <div>

          <b-form @submit.stop.prevent="onSubmit" v-show="!tabInfo">
          
          <div class="animated fadeIn">

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Id"
                  label-for="id"
                  :label-cols="3"
                  :horizontal="true">
                  {{ selectedItem.id  }}
                </b-form-group>          
                </b-form>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Documento"
                  label-for="name"
                  :label-cols="3"
                  :horizontal="true">
                  {{ selectedItem.name  }}
                  
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Arquivos"
                  label-for="name"
                  :label-cols="3"
                  :horizontal="true">
                  
                  <div>
                    <b-row v-for="fileItem in selectedItem.files" :key="fileItem.id">
                      <b-col><i class="fa fa-file-o text-primary"></i> {{ fileItem.filename }}</b-col>
                    </b-row>
                  </div>
                  
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <div id="add-attachments-modal">
                <b-form @submit.stop.prevent="onSubmit">

                  <b-form-group
                  description=""
                  label=""
                  label-for="name"
                  :label-cols="3"
                  :horizontal="true">
                  <div class="d-flex mb-3">
                    <file-drop-area-component v-model="image" class="w-100"></file-drop-area-component>
                </div>
                <div class="d-flex justify-content-center">
                    <b-img v-if="hasImage && isImage(this.image.name)" :src="imageSrc" class="upload-img rounded" fluid block rounded></b-img>
                </div>
                <p></p>
                <div class="d-flex mb-3  justify-content-center">
                    <b-button v-if="hasImage" variant="danger" class="ml-3" @click="clearImage">Limpar Arquivo</b-button>
                    &nbsp;
                    <b-button :disabled="!hasImage" variant="primary" @click="submitAvatar">Carregar arquivo</b-button>
                </div> 
                </b-form-group>      

                   

                </b-form>
              </div>
              </b-col>

            </b-row>
        </div>
        </b-form>


        <b-form @submit.stop.prevent="onSubmit" v-show="tabInfo">
          
          <div class="animated fadeIn">

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Documento"
                  label-for="name"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Título"
                  label-for="title"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.title" id="title" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Descrição"
                  label-for="description"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-textarea
                    id="textarea"
                    v-model="selectedItem.description"
                    placeholder=""
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                
                <b-form>
                  <b-form-group
                  description=""
                  label="Conteúdo"
                  label-for="content"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-textarea
                    id="textarea"
                    v-model="selectedItem.content"
                    placeholder=""
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            
            <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Publicado por"
                  label-for="publisherName"
                  :label-cols="3"
                  :horizontal="true">
                  <b-form-input v-model="selectedItem.publisherName" id="publisherName" type="text"></b-form-input>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>

            <b-row>
            <b-col md="12">
            <b-form>
              <b-form-group label="Publicado em" 
                description=""
                label-for="publishedIn"
                :label-cols="3"
                :horizontal="true"
              >
              <b-input-group>
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class='fa fa-calendar'></i>
                  </span>
                </div>
                <masked-input
                  type="tel"
                  name="publishedIn"
                  class="form-control"
                  v-model="selectedItem.publishedIn"
                  :mask="[/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/  ]"
                  :guide="true"     
                  
                  >
                </masked-input>
              </b-input-group>

              <!--
              <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="[1]">
                <b-form-checkbox :value="selectedUser.phoneExtPublic">Exibir no portal</b-form-checkbox>              
              </b-form-checkbox-group>
              -->

            </b-form-group>
          </b-form>
      </b-col>
    </b-row>

    <b-input-group class="mb-4">
        <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
    </b-input-group>
  
    <div slot="footer" class="text-right">
      <!--
      <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
      <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
      -->
      <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Documento</span></b-button>
     
    </div>
          
  </div>
  </b-form>

  </div>
  
      </b-card>

        
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";

  import { Switch as cSwitch } from '@coreui/vue'

  
/*
Máscara
*/
import MaskedInput from 'vue-text-mask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'

  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', title: '', publishedIn: '', publisherName: '', st: 'A'}
  
  export default {
    name: 'tables',
    components: {
      Event,
      MaskedInput,
      cSwitch,
      FileDropAreaComponent
    },
    data: () => {
      return {
        companyDDL: [],

        tabInfo: true,

        // Imagem
        image: null,
        imageSrc: null,



        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },

        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: 0,
          key: '',
          public: -1,
          status: 0
        },

        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",

        selectedItem: newItem,
        items: [
          {id: 1, st: 'A', title: 'Compras', summary: 'Informática/TI', enddate: "2022-01-29", publishedin: '2022-01-29 12:21:11', publisher: 'Equipe A6i', icon: 'img/document.png', ispublic: 0, url: 'http://www.google.com', _rowVariant: 'none'},
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "100px" } },
          //{key: 'id' },
          {key: 'name', label: 'Documento', sortable: true },
          //{key: 'enddate', label: 'Publicar até', sortable: true, thStyle: { width: "150px" } },
          //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        publicddl: [
          {
            text: '- Todos -',
            value: -1
          },
          {
            text: 'Público',
            value: "1"
          },
          {
            text: 'Privado',
            value: "0"
          }
        ],
        /*
        fields: [
            'show_details',
            { key: 'first_name', sortable: true }, 
            { key: 'last_name', sortable: true }
        ],
        items: [
          { isActive: true, age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { isActive: false, age: 89, first_name: 'Geneva', last_name: 'Wilson', _showDetails: false },
          { isActive: true, age: 38, first_name: 'Jami', last_name: 'Carney' }
        ],
        */
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || item.title.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                && (this.filters.status == 0 || this.filters.status == item.st)
                && (this.filters.public == -1 || this.filters.public == item.ispublic)
            })
        }
        catch(e) {
            return this.items;
        }
      },
      hasImage() {
        console.log(this.image)
        return !!this.image;
        }
    },
    watch: {
      image(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            base64Encode(newValue)
              .then(value => {
                this.imageSrc = value;
              })
              .catch(() => {
                this.imageSrc = null;
              });
          } else {
            this.imageSrc = null;
          }
        }
      }
    },
    methods: {
      // ImagemubmitAvata
      async saveAvatar(documentId, currentUser) {

        let formData = new FormData();
        formData.append('file', this.image);
        formData.append('documentId', documentId);
        formData.append('uid', currentUser.id);
        formData.append('sid', currentUser.sid);

        await axios.post(
            this.$store.state.ws_url + "/portaldocument/file", formData
        ).catch(function (error) {
          console.log(error);
        });

        if(resp && resp.data && resp.data.code && resp.data.code > 0) {
          self.rand = Date.now();
          
        }        
      },
      submitAvatar() {
        this.saveAvatar(this.selectedItem.id, this.$store.state.currentUser);

      },
      isImage(url) {
        return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
      },
      clearImage() {
        this.image = null;
        },

        onSubmit() {
          if (!this.image) {
              alert("Por favor, selecione uma imagem");
              return;
          }

          alert("Form submitted!");
        },


      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      changeStatusClick(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';

          this.saveItem(item);
        }
      },
      async saveItem(item) {
        var s = this
        var currentUser = this.$store.state.currentUser;
        s.saveEnabled = false

        item['st'] = 'A'
        item['companyId'] = s.$store.state.config.companyId
        item['uid'] = currentUser.id
        item['sid'] = currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/portaldocument",
            item
        ).then(function(resp) {
          s.saveEnabled = true;
          s.editModal = false;
          s.refreshData();

          toast ({
            type: VueNotifications.types.success,
            title: 'Documento',
            message: 'Documento salvo com sucesso.',
            timeout: 5000
          })
        }).catch(function(error) {
          console.log(error)
        })

      },
      save() {
        this.saveItem(this.selectedItem);
      },
      enableDisable() {
        console.log('Habilitando/desabilitando documento')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        this.tabInfo = true
        if(item == null) {
            this.selectedItem = { ...newItem};      
        }
        else {
            this.selectedItem = { ...item} //JSON.parse(JSON.stringify(item));
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
          if(!this.tableSelectable) {
            console.log(item);
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      async refreshData() {
          var s = this
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;
          await axios.get(
              this.$store.state.ws_url + "/portaldocument?companyId=" + s.$store.state.config.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
             s.items = resp.data.obj;
          }).catch(function(error) {
             console.log(error)
          })
         
          this.isBusy = false;
        
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.refreshData();
    }
  }
  </script>
  
<style scoped>
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}


.upload-img {
  max-width: 300px;
  max-height: 200px;

  /*
  width: 100px;
  height: 100px;
  object-fit: cover;
  overflow: hidden;  
  */
}

div#add-attachments-modal {
/*    div.modal-dialog {
      transition: max-width 0.3s ease-out, transform 0.3s ease-out;
    }
  
  */
    .col.file-drop-column {
      flex-shrink: 1;
    }
    div.file-drop-area {
      border: 2px dashed rgba(0, 0, 0, 0.25);
      input.file-input {
        position: absolute;
        height: 0;
      }
    }
  }


.col-xs-5ths,
.col-sm-5ths,
.col-md-5ths,
.col-lg-5ths {
    position: relative;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
}

.col-xs-5ths {
    width: 20%;
    float: left;
}

@media (min-width: 768px) {
    .col-sm-5ths {
        width: 20%;
        float: left;
    }
}

@media (min-width: 992px) {
    .col-md-5ths {
        width: 20%;
        float: left;
    }
}

@media (min-width: 1200px) {
    .col-lg-5ths {
        width: 20%;
        float: left;
    }
}

.ql-editor{
    min-height:200px;
}
</style>